import { SET_PROFILE_DATA } from './mutations.type'

export default {
  [SET_PROFILE_DATA](state, data) {
    state.data = data
  }
}
